var _metadata, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackagePin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 42,
    viewBox: "0 0 34 42.5",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata14"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs12"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.5 -4.25)",
    id: "g6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9e71",
    className: "a",
    d: "M21,2A17,17,0,0,0,4,18.831C4,30.475,18.981,43.438,19.619,43.99a2.125,2.125,0,0,0,2.763,0C23.125,43.438,38,30.475,38,18.83A17,17,0,0,0,21,2Zm0,23.375a7.438,7.438,0,1,1,7.438-7.437A7.437,7.437,0,0,1,21,25.375Z",
    transform: "translate(4.5 2.25)",
    id: "path4"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.188,
    cy: 3.188,
    r: 12,
    fill: "white",
    transform: "translate(22.313 18)",
    id: "circle2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagePin);
export default __webpack_public_path__ + "static/media/PackagePin.1cf5429a32d51f9923dc9a6d020e5785.svg";
export { ForwardRef as ReactComponent };